import { PrimaryTheme } from '@deckee/deck-hand';

// Definitions of colours only used within the `Weather` feature
// TODO: This needs to be moved to a sub theme later that extends our primary theme
const WeatherTheme = {
  colors: {
    wind: '#1949d2',
    windgust: PrimaryTheme.colors.primary,
    swell: '#28a1ff',
    swellfill: '#CEF0FF',
    swellperiod: '#ff8d00',
    tides: '#393472',
    tidesfill: '#acb1e5',
    rain: '#00a6a4',
    rainsecondary: '#207e86',
    rainfill: '#BFF2F1',
    moon: '#393472',
    moonsecondary: '#acb1e5',
    airpressure: '#c44d4d',
    humidity: '#00a62a',
    temperature: PrimaryTheme.colors.danger,
    uv: '#f7941d',
    uvfill: '#fde4c4',
  },
};

export default WeatherTheme;
